import {
    Box,
    Center,
    Divider,
    Heading,
    HStack,
    SimpleGrid,
    Text
} from "@chakra-ui/react";
import TeamMember from "./TeamMember";

import BackgroundImage from "../images/background-team.webp";
import DrZen from "../images/DrZen.gif";
import DrSimon from "../images/DrSimon.gif";
import DrCrosmoDev from "../images/DrCrosmoDev.gif";
import DrMod from "../images/cellardwellar.png";
import AtlasDragon from "../images/AtlasDragon.png";

const TeamView: React.FC = () => {
    return (
        <>
            <Box
                position={"fixed"}
                backgroundImage={`url(${BackgroundImage})`}
                backgroundSize="cover"
                width={'100%'}
                height={'100%'}
                opacity={0.5}
                zIndex={-3}
            />

            <Center>
                <Box>
                    <Center>
                        <Box maxWidth={480}>
                            <Box textAlign={"center"}>
                                <Text fontSize={'3xl'} mt={8} mb={16} px={6} borderRadius={24} bgColor='black'>CORE TEAM</Text>
                            </Box>
                        </Box>
                    </Center>

                    <SimpleGrid
                        columns={{ base: 1, md: 2, xl: 3 }}
                        spacing={8}
                        my={8}
                        mx={"auto"}
                    >
                        <TeamMember
                            name={"Dr Zen"}
                            role={["Founder", "Artist"]}
                            image={DrZen}
                        />

                        <TeamMember
                            name={"Dr Simon"}
                            role={["Founder", "Artist"]}
                            image={DrSimon}
                        />

                        <TeamMember
                            name={"Dr CrosmoDev"}
                            role={["Tech Lead", "Dev"]}
                            image={DrCrosmoDev}
                        />

                        <TeamMember
                            name={"Cellar Dwellar"}
                            role={["Dr Moderator"]}
                            image={DrMod}
                        />

                        <TeamMember
                            name={"Atlas Dragon"}
                            role={["Community Manager"]}
                            image={AtlasDragon}
                        />
                    </SimpleGrid>
                </Box>
            </Center>
        </>
    )
};

export default TeamView;